import { twMerge } from "tailwind-merge";

import { Divider } from "@treezor/design-system";

import { IItemGroup, ItemGroup } from "./ItemGroup";

export interface IListGroup {
  items: IItemGroup[];
  className?: string;
}

export function ListGroup({ items, className }: IListGroup) {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-3.5 py-3.5 px-0 border-2 border-primary rounded-200 bg-primary w-fit",
        className,
      )}
    >
      {items.map((item, index) => (
        <div className="flex flex-col gap-3.5" key={`item-${index}`}>
          <ItemGroup {...item} />
          {index !== items.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  );
}
